import { TextAlignment } from '@tink/config/src/tinkLinkConfig';
import { styled } from '../../core/theme/styled';

export type StyledTextAlignmentContainerProps = {
  textAlignment: TextAlignment;
};

export const StyledTextAlignmentContainer = styled.div<StyledTextAlignmentContainerProps>`
  text-align: ${({ textAlignment }) => textAlignment.toLowerCase()};
`;
